import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "LogiCar - Smart Car Maintenance Tracker", 
  description = "Never miss a service again with AI-powered car maintenance advice and smart reminders.",
  keywords = "car maintenance app, vehicle service tracker, automotive maintenance",
  canonical = "https://www.logicarapp.com",
  ogImage = "/og-image.jpg",
  ogType = "website"
}) => {
  const fullTitle = title.includes('LogiCar') ? title : `${title} | LogiCar`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={`https://www.logicarapp.com${ogImage}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="LogiCar" />
      
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`https://www.logicarapp.com${ogImage}`} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SEO;
